// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import {
//   Box, Typography, IconButton, Dialog, DialogContent, DialogTitle
// } from '@mui/material';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import CloseIcon from '@mui/icons-material/Close';
// import TableComponent from '../../../Components/TableComponent/TableComponent';
// import { SnackBarComponent } from '../../../Components/snackBar/snackBar';
// import { API_BASE_URL } from '../../../config';
// import { LoadingSpinner } from '../../../Components/spinner/spinner';
// import { useTranslation } from 'react-i18next';

// export const StaffLegalTeamComponent = () => {
//   const { t } = useTranslation();

//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

//   const [openDialog, setOpenDialog] = useState(false);
//   const [selectedImage, setSelectedImage] = useState('');

//   const columns = [
//     { id: 'slNo', field: 'slNo', headerName: t('legalTeam.slNo'), width: 80 },
//     { id: 'name', field: 'name', headerName: t('legalTeam.name'), width: 200 },
//     { id: 'designation', field: 'designation', headerName: t('legalTeam.designation'), width: 200 },
//     { id: 'roles', field: 'roles', headerName: t('legalTeam.roles'), width: 300 },
//     {
//       id: 'photo',
//       field: 'photo',
//       headerName: t('legalTeam.photo'),
//       width: 120,
//       renderCell: (params) => (
//         <IconButton
//           onClick={() => handleOpenImage(params.value)}
//           color="primary"
//         >
//           <VisibilityIcon />
//         </IconButton>
//       ),
//     },
//   ];

//   const handleOpenImage = (imageUrl) => {
//     setSelectedImage(imageUrl);
//     setOpenDialog(true);
//   };

//   const handleCloseDialog = () => {
//     setOpenDialog(false);
//     setSelectedImage('');
//   };

//   useEffect(() => {
//     axios.get(`${API_BASE_URL}/home-notification/legal-team/`)
//       .then(response => {
//         const apiData = response.data.map((item, index) => ({
//           id: item.id,
//           slNo: index + 1,
//           name: item.name,
//           designation: item.designation,
//           roles: item.roles_and_responsibility,
//           photo: item.photo,
//         }));
//         setRows(apiData);
//         setSnackbarMessage(t('legalTeam.successMessage'));
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//         setLoading(false);
//       })
//       .catch(error => {
//         console.error('Failed to fetch legal team data:', error);
//         setSnackbarMessage(t('legalTeam.errorMessage'));
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         setLoading(false);
//       });
//   }, [t]);

//   const handleSnackbarClose = () => {
//     setSnackbarOpen(false);
//   };

//   if (loading) {
//     return <LoadingSpinner size={30} />;
//   }

//   return (
//     <Box
//       sx={{
//         width: '100%',
//         mt: 8,
//         mb: 1,
//         borderRadius: 2,
//         boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//         backgroundColor: '#fff',
//       }}
//     >
//       <Box display="flex" justifyContent="center" backgroundColor="rgba(195, 234, 203, 0.1)" mb={2}>
//         <Typography variant="h4" component="h1" align="center" sx={{ fontWeight: 'bold' }}>
//           {t('legalTeam.heading')}
//         </Typography>
//       </Box>

//       <TableComponent
//         columns={columns}
//         rows={rows}
//         manageColumnStatus={true}
//         enableSort={true}
//         sx={{
//           '& .MuiDataGrid-columnHeaders': {
//             backgroundColor: '#1976d2',
//             color: '#fff',
//             fontWeight: 'bold',
//           },
//         }}
//       />

//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={handleSnackbarClose}
//       />

//       {/* Image Popup Dialog with Close Icon */}
//       <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
//         <DialogTitle sx={{ m: 0, p: 2 }}>
//           <IconButton
//             aria-label="close"
//             onClick={handleCloseDialog}
//             sx={{
//               position: 'absolute',
//               right: 8,
//               top: 8,
//               color: (theme) => theme.palette.grey[500],
//             }}
//           >
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent sx={{ textAlign: 'center' }}>
//           {selectedImage ? (
//             <img
//               src={selectedImage}
//               alt={t('legalTeam.altText')}
//               style={{ maxWidth: '100%', maxHeight: '70vh', borderRadius: '8px' }}
//             />
//           ) : (
//             <Typography>{t('legalTeam.noImage')}</Typography>
//           )}
//         </DialogContent>
//       </Dialog>
//     </Box>
//   );
// };


import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Box,
  Typography,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import TableComponent from '../../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../../Components/snackBar/snackBar';
import { API_BASE_URL } from '../../../config';
import { LoadingSpinner } from '../../../Components/spinner/spinner';

export const StaffLegalTeamComponent = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState(['All']);
  const [categoryFilter, setCategoryFilter] = useState('All');

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 80 },
    { id: 'name', field: 'name', headerName: 'Name', width: 180 },
    { id: 'designation', field: 'designation', headerName: 'Designation', width: 180 },
    { id: 'qualification', field: 'qualification', headerName: 'Qualification', width: 180 },
    { id: 'roles', field: 'roles', headerName: 'Roles & Responsibility', width: 250 },
    {
      id: 'appointment_date',
      field: 'appointment_date',
      headerName: 'Appointment Date',
      width: 140,
      renderCell: (params) => (params.value ? new Date(params.value).toLocaleDateString() : ''),
    },
    {
      id: 'renewal_date',
      field: 'renewal_date',
      headerName: 'Renewal Date',
      width: 140,
      renderCell: (params) => (params.value ? new Date(params.value).toLocaleDateString() : ''),
    },
    { id: 'catogary', field: 'catogary', headerName: 'Category', width: 140 },
    { id: 'rank', field: 'rank', headerName: 'Rank', width: 90 },
    {
      id: 'photo',
      field: 'photo',
      headerName: 'Photo',
      width: 100,
      renderCell: (params) =>
        params.value ? (
          <IconButton onClick={() => handleOpenImage(params.value)} color="primary">
            <VisibilityIcon />
          </IconButton>
        ) : (
          'N/A'
        ),
    },
  ];

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
    fetchLegalTeam(categoryFilter);
  }, [categoryFilter]);

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/home-notification/legal-team/`);
      const uniqueCategories = Array.from(
        new Set(response.data.map((item) => item.catogary).filter((cat) => !!cat))
      );
      setCategories(['All', ...uniqueCategories]);
    } catch (error) {
      console.error('Failed to fetch categories:', error);
      setSnackbarMessage('Failed to load categories.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      setCategories(['All']);
    }
  };

  const fetchLegalTeam = (category) => {
    setLoading(true);
    let url = `${API_BASE_URL}/home-notification/legal-team/`;
    if (category && category !== 'All') {
      url += `?catogary=${encodeURIComponent(category)}`;
    }
    axios
      .get(url)
      .then((response) => {
        const data = response.data.map((item, index) => ({
          id: item.id,
          slNo: index + 1,
          name: item.name,
          designation: item.designation,
          qualification: item.qualification,
          roles: item.roles_and_responsibility,
          appointment_date: item.appointment_date,
          renewal_date: item.renewal_date,
          catogary: item.catogary,
          rank: item.rank,
          photo: item.photo,
        }));
        setRows(data);
        setLoading(false);
        setSnackbarMessage('Legal team data loaded successfully.');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
      })
      .catch((error) => {
        console.error('Failed to fetch legal team data:', error);
        setSnackbarMessage('Failed to load legal team data.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setLoading(false);
      });
  };

  const handleCategoryChange = (event) => {
    setCategoryFilter(event.target.value);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleOpenImage = (imageUrl) => {
    setSelectedImage(imageUrl);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedImage('');
  };

  if (loading) {
    return <LoadingSpinner size={30} />;
  }

  return (
    <Box
      sx={{
        width: '100%',
        mt: 8,
        mb: 1,
        borderRadius: 2,
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        backgroundColor: '#fff',
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        bgcolor="rgba(195,234,203,0.1)"
        p={2}
        mb={2}
      >
        <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
          Legal Team
        </Typography>
        <FormControl sx={{ minWidth: 180 }}>
          <InputLabel id="category-filter-label">Category Filter</InputLabel>
          <Select
            labelId="category-filter-label"
            value={categoryFilter}
            label="Category Filter"
            onChange={handleCategoryChange}
            size="small"
          >
            {categories.map((cat) => (
              <MenuItem key={cat} value={cat}>
                {cat}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <TableComponent
        columns={columns}
        rows={rows}
        manageColumnStatus
        enableSort
        sx={{
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#1976d2',
            color: '#fff',
            fontWeight: 'bold',
          },
        }}
      />

      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />

      <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ m: 0, p: 2 }}>
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ textAlign: 'center' }}>
          {selectedImage ? (
            <img
              src={selectedImage}
              alt="Legal Team Member"
              style={{ maxWidth: '100%', maxHeight: '70vh', borderRadius: '8px' }}
            />
          ) : (
            <Typography>No Image Available</Typography>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
};
